module.exports = __webpack_public_path__ + "static/media/illustration.ad3bfa84.svg";